const url ='/modules_list/'

export default {
    getAllModules:(axios)=>{
        return axios.get(url)
        .then(response=> {return {data: response.data}})
        .catch(error=> {return {error: error?.response?.data}})
    }
}